import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Charity, CharityStore, Environment, ENVIRONMENT, Screening } from '@domains';
import { Deserialize, Serialize } from 'cerialize';
import { BaseApiService } from '../base-api.service';
import { MarketsService } from './markets.service';

@Injectable({
  providedIn: 'root',
})
export class CharityService extends BaseApiService<Charity> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
    private marketsService: MarketsService
  ) {
    super(config, http, 'charities', Charity, 'Charity', [], ['market']);
  }

  override deserialize(data: any): Charity {
    const res = new Charity({
      ...Deserialize(data, Charity),
      ...(data.stores
        ? {
            stores: data.stores.map(
              (s: any) => new CharityStore(Deserialize(s, CharityStore))
            ),
          }
        : {}),
      ...(data.screening
        ? {
            screening: new Screening(Deserialize(data.screening, Screening)),
          }
        : {}),
    });
    if (res.logo && !res.logo.startsWith('http')) {
      res.logo = this.config.urls.baseUrl + res.logo;
    }
    if (
      res.meta?.splitScreenConfig &&
      !res.meta.splitScreenConfig.startsWith('http')
    ) {
      res.meta.splitScreenConfig =
        this.config.urls.baseUrl + res.meta.splitScreenConfig;
    }
    res.setInitialValue();
    return res;
  }

  override serialize(item: Charity) {
    return {
      ...Serialize(
        {
          ...item,
          ...(item.market
            ? {
                market: { ...this.marketsService.serialize(item.market) },
              }
            : {}),
        },
        Charity
      ),
    };
  }
}
